import groq from 'groq';

import { ASSET, RICH_TEXT } from '../common';

export const AB_PATHS = groq`
  _type,
  title,
  subtitle,
  paths[] {
    title,
    image {
      ${ASSET}
    },
    isDeEmphasised,
    facts[] {
      title,
      description[] {
        ${RICH_TEXT}
      }
    },
  },
  showABOverlay
`;

export const AB_PATHS_BLOCK = groq`
  _type == 'abPaths' => @ -> {
    ${AB_PATHS}
  }
`;
